import { useQuery } from '@apollo/client';
import { GetViewerTranscriptRequestsDocument } from '@sandtech-hub-monorepo/ehub-client';
import { RequestPrefill } from './RequestOfficialTranscriptModal';
import TranscriptRequestCard from './TranscriptRequestCard';

interface Props {
  /** Opens the request modal prefilled from a rejected request. */
  onResubmit: (prefill: RequestPrefill) => void;
}

const TranscriptRequestsStatus = ({ onResubmit }: Props) => {
  const { data } = useQuery(GetViewerTranscriptRequestsDocument, {
    fetchPolicy: 'cache-and-network',
  });

  const requests = data?.viewer?.transcriptRequests ?? [];

  if (requests.length === 0) {
    return (
      <div className="w-full py-12 text-center text-sm text-muted-foreground">
        You haven&apos;t requested any official transcripts yet.
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col gap-3">
      {requests.map((r) => (
        <TranscriptRequestCard key={r.id} request={r} onResubmit={onResubmit} />
      ))}
    </div>
  );
};

export default TranscriptRequestsStatus;
